import { action, observable, makeObservable, computed } from 'mobx'
import { Nullable } from 'types/definitions'
import DocumentType from 'documents/DocumentType'

export class DocumentCreationItemViewModel {
  @observable file: File
  @observable types: Nullable<DocumentType[]> = null
  @observable selectedType: Nullable<DocumentType> = null
  @observable typeName: string = 'Select type'

  constructor(
    file: File,
    documentTypes: DocumentType[],
    private incrementTypeSelected: () => void,
  ) {
    makeObservable(this)
    this.file = file
    this.types = documentTypes
  }

  @computed
  get isPlaceholder() {
    return this.selectedType === null && this.typeName === 'Select type'
  }

  @action
  setDocumentType(type: DocumentType | null) {
    if (this.typeName === 'Select type') {
      this.incrementTypeSelected()
    }

    if (!type) {
      this.typeName = 'Other documents'
    } else {
      this.typeName = type.name
    }

    this.selectedType = type
  }
}
